import { useEffect, useState, useRef } from "react";
import "../../assets/scss/login-forms.scss";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import {
  getTenantId,
  getServiceCodeForgotPwd,
  getTenantGroupId,
  currentDomain,
  get_InValid_Attempt_For_Captcha_Display,
} from "../../utils/general-config";
import "react-toastify/dist/ReactToastify.css";
import {
  CreateUUID,
  getPortalCD,
  isUserLoggedIn,
  readCookie,
  UserDocMapping,
  PerquisiteBountyEnable,
  checkQueryParams,
  createCookie,
  deleteCookie,
  sendWelcomeEmail,
  isLinkValid,
  getQueryParam,
  getDeviceType,
  currentPortalCD,
} from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import { validateEmail, validatePassword } from "../../validators/genericValidator";
import {
  ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
  ABTEST_IMAGE_AI_FUNNEL_COOKIE,
  ABTEST_IMAGE_AI_GENERATION,
  // ABTESTID_PDFSIMPLI_EDITOR,
  // ABTESTID_PDFSIMPLI_EDITOR_COOKIE,
  // ABTESTID_VWO_PAYMENT_CHECKOUT,
  // ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE,
  APP_INSIGHT_ERROR,
  APP_INSIGHT_EVENT,
  CategoryName,
  DomainName,
  EMPTY_GUID,
  DASHBOARD_ABTESTID,
  DASHBOARD_ABTESTID_COOKIE,
  // ABTEST_COMPARE_PDF_LP_US_ENG,
  // ABTEST_COMPARE_PDF_LP_COOKIE,
} from "../../utils/constants";
import i18next from "i18next";
import PathHelper, {
  getDashboardLinkWithLocale,
  getLinkWithLocale,
  redirectToDashboardWithLocale,
} from "../../utils/path-helper";
import { getSignUpLink, getForgetPasswordLink } from "../../utils/path-helper";
import {
  APP_NAVIGATION,
  // ABTESTID_SUMMARIZER,
  // ABTESTID_TRANSLATIONOCR,
  ABTEST_SUMMARIZER_COOKIE,
  ABTEST_TRANSLATIONOCR_COOKIE,
  // ABTESTID_ANNOTATION_PROVIDER,
  // ABTEST_ANNOTATION_PROVIDER_COOKIE,
  // ABTESTID_VWO_PAYMENT_FUNNEL,
  // ABTEST_VWO_PAYMENT_FUNNEL_COOKIE,
  // ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE,
  // ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE,
  // ABTEST_APP_EDITOR,
  // ABTEST_APP_EDITOR_COOKIE,
} from "../../utils/constants";

import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import {
  authUser,
  DeleteTemplateDocId,
  eventServicePost,
  getAddress,
  GetEditorQueryInfo,
  saveUserAddress,
  signUpAsExternalUser,
  SignupSuccessEvent,
  updateUserGuid,
} from "../sign-up/actions";
import {
  signInUser,
  getUserDocumentAttributes,
  validateGuestToken,
  getUserAbridged,
  GetTemplateDocId,
  generatePDFPath,
  triggerResetPasswordFromSignIn,
} from "./actions";
import { DomainEnum } from "../../services/enum/environment-enum";
import {
  getResumeBuildBaseURL,
  getPdfSimpliBaseURL,
  getSignSimpliBaseURL,
  getWorksimpliEndPoint,
  getLegalSimpliBaseURL,
} from "../../services/api-constants";
import ReactLoader from "../../components/resumebuild-loader/component";
import ResumeBuildSignIn from "./rb";
import SignSimpliSignIn from "./ss";
import LegalSimpliSignIn from "./ls";
import PdfSimpliSignIn from "./ps";
import {
  addWelcomeDocument,
  DocOperationJobStatusWithInterval,
  getDocOperationBlobData,
  ProcessDocOperationRequest,
  ProcessSignInRequest,
  ProcessSignUpRequest,
} from "../../utils/document-helper";
import { getABtestData, SwitchVisitorUserAbTest } from "./actions";
import { jwtDecode } from "jwt-decode";
import { updateCookie, ConductABTest, retrieveAbTestConfiguration } from "../../utils/abtest-helper";
import { signInJcUser } from "./actions";
import PSRSignIn from "./PSReSkining/Psr";
import { useNavigate, useParams } from "react-router-dom";
import { saveMfaVerificationData } from "../verify-user/actions";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import UserServiceApi from "../../services/user-service-api";
import { clearIndexedDB } from "../../utils/helpers";

const SignIn = ({ funnelStep }) => {
  let { locale } = useParams();
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(window.location.search);
  let signUpLink = getSignUpLink(locale, window.location.search);
  let forgetpwdLink = getForgetPasswordLink(locale);
  const navigate = useNavigate();
  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState();
  const [disableBtn, setdisableBtn] = useState(false);
  const [showLoader, setShowLoader] = useState("d-none");
  const [isProcessing, setIsProcessing] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [termsOfUse, setTermsOfUse] = useState("");
  let PathRedirectDashboard = PathHelper(APP_NAVIGATION.DASH);
  let pathRedirect = PathHelper(APP_NAVIGATION.SINI);
  let subDomainParam;
  let isOfferPlanUser = false;
  const isSecureSimpli = currentDomain() === DomainEnum.PDFSIMPLI && getPortalCD(locale) === "PSSC";
  const isPSRB = currentDomain() === DomainEnum.PDFSIMPLI && getPortalCD(locale).indexOf("PSRB") > -1;
  const [isOfferPlanValid, setOfferPlanValid] = useState(false);
  const [loginAttemptCount, setLoginAttemptCount] = useState(0);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  if (queryParams.has("q")) {
    subDomainParam = queryParams.get("q");
  }
  const domain = currentDomain()?.toLowerCase() || "";

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        setLoginError(true);
        setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      setLoginError(true);
      setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const appleLogin = async ({ user, authorization }) => {
    try {
      const { id_token: idToken } = authorization;
      if (!idToken) {
        setLoginError(true);
        // setLoginErrorMessage("Authorization token not found.");
        return;
      }
      const decodedToken = jwtDecode(idToken);
      const email = user?.email || decodedToken?.email;
      const fullName =
        user?.name?.firstName && user?.name?.lastName ? `${user.name.firstName} ${user.name.lastName}` : "";
      const sub = decodedToken?.sub;
      responseApple({ ...decodedToken, fullName }, authorization?.code);
    } catch (error) {
      console.error("Error during Apple login:", error);
      setLoginError(true);
      setLoginErrorMessage(error.message || "Failed to log in with Apple.");
    }
  };

  const IsValidGuest = () => {
    if (queryParams.has("gusr")) {
      let params = {
        InvitationToken: queryParams.get("gusr"),
        ParentGuid: queryParams.get("pgid"),
        TenantGroupId: getTenantGroupId(),
      };

      validateGuestToken(params).then((response) => {
        if (!!response && response.isTokenValid) {
          //TODO:set email in the textbox response.Email
          setEmail(response.email);
          setdisableBtn(true);
        }
      });
    }
  };

  useEffect(() => {
    // Check for Auto Login
    if (locale === undefined) {
      const lng = localStorage.getItem("i18nextLng");
      locale = lng === "en" ? "" : lng;
    }
    const token = new URLSearchParams(window.location.search).get("token");
    if (token) {
      try {
        const decoded = atob(token);
        const parts = decoded.split("|");

        if (parts.length !== 3) {
          console.log("Invalid token format");
          return;
        }
        const [userGuid, email, validDate] = parts;
        const expiry = new Date(validDate);
        const now = new Date();
        if (isNaN(expiry.getTime()) || expiry <= now) {
          console.log("Token expired or invalid");
          return;
        }

        setShowLoader("d-block");
        setdisableBtn(true);

        const authData = {
          userGuid: userGuid,
          username: email.trim(),
          email: email.trim(),
        };

        authUser(authData, subDomainParam)
          .then(async (authResponse) => {
            if (!authResponse) return;

            createCookie("userguid", userGuid, 1);
            
            const eventData = 
            {
              Id: CreateUUID(),
              UserId: userGuid,
              VisitorId: readCookie("visitorGuid"),
              VisitId: readCookie("visitGuid"),
            };
            eventServicePost(eventData).then((serviceResponse) => { });




            await clearIndexedDB();

            const response = await getUserAbridged();

            const billingUrl =
              window.location.origin +
              "/app" +
              getLinkWithLocale(locale, "billing/billing-transfer/");

            if (response) {
              const isPerquisiteEnabled = PerquisiteBountyEnable(
                response.perquisiteBountyKey,
                response.userGuid
              );

              if (!isPerquisiteEnabled) {
                window.location.assign(billingUrl);
              } else {
                NavigationHandler(
                  userGuid,
                  isPerquisiteEnabled
                );
              }
            } else {
              window.location.assign(billingUrl);
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setdisableBtn(false);
            setLoginError(true);
            setLoginErrorMessage(error.message);
          });

      } catch (err) {
        setShowLoader("d-none");
        setdisableBtn(false);
        console.log("Invalid token");
      }

      // return;
    }

    if (getQueryParam("opt") && domain === DomainEnum.PDFSIMPLI) {
      const offerType = getQueryParam("opt");
      isOfferPlanUser = ["1", "10"].includes(offerType);
      if (isOfferPlanUser) {
        createCookie("opt", offerType, 1);
        const isOfferEmailLinkValid = isLinkValid();
        setOfferPlanValid(isOfferEmailLinkValid);
        if (!isOfferEmailLinkValid) {
          window.location.href = getPdfSimpliBaseURL;
        }
      }
    }

    IsValidGuest();
    if (isUserLoggedIn()) {
      getUserAbridged().then((response) => {
        if (!!response) {
          NavigationHandler(
            readCookie("userguid"),
            PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
          );
        } else {
          NavigationHandler(readCookie("userguid"), false);
        }
      });
    }
  }, []);
  const backClickHandler = () => {
    navigate(pathRedirect.back);
  };

  const resetCaptcha = () => {
    if (showCaptcha && recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  const onEmailChangeHandler = (e) => {
    setEmailError(false);
    setPasswordError(false);
    setLoginError(false);
    //setCaptchaToken(null);
    //resetCaptcha();
    const {
      target: { value },
    } = e;
    setEmail(value);
  };
  const onPwdChangeHandler = (e) => {
    setPasswordError(false);
    setLoginError(false);
    //setCaptchaToken(null);
    //resetCaptcha();
    const {
      target: { value },
    } = e;
    setPwd(value);
  };
  const onPasswordKeyPress = (e) => {
    const { charCode } = e;
    if (charCode === 13) {
      onSignIn();
    }
  };

  const onCaptchaSuccess = (token) => {
    setCaptchaToken(token);
    if (token) {
      setShowCaptcha(false);
      setLoginAttemptCount(0);
      setLoginError(false);
    }
  };

  const onSignIn = async () => {
    setShowLoader("d-block");
    setdisableBtn(true);
    let uid = CreateUUID();
    setLoginError(false);

    if (showCaptcha && !captchaToken) {
      setLoginError(true);
      setLoginErrorMessage(t("sign_up.im_not_robot"));
      setShowLoader("d-none");
      setdisableBtn(false);
      return;
    }

    const isValid = validateData();
    if (!isValid) {
      setShowLoader("d-none");
      setdisableBtn(false);
      return;
    }

    const params = {
      username: emailId.trim(),
      password: pwd.trim(),
      tenantGroupId: getTenantGroupId(),
      parentId: queryParams.get("pgid"),
      invitationToken: queryParams.get("gusr"),
      captchaToken: captchaToken,
    };

    try {
      const signInResponse = await signInUser(params, domain);
      setLoginAttemptCount(0);
      setShowCaptcha(false);
      setCaptchaToken(null);
      await clearIndexedDB();
      signingResponse(signInResponse);
    } catch (error) {
      setShowLoader("d-none");
      // setLoginError(true);
      // setLoginErrorMessage(error.message);
      setPasswordError(true);
      setPwd("");

      const newAttemptCount = loginAttemptCount + 1;
      setLoginAttemptCount(newAttemptCount);
      setCaptchaToken(null);

      if (newAttemptCount >= get_InValid_Attempt_For_Captcha_Display()) {
        setShowCaptcha(true);
        resetCaptcha();
      }

      if (error?.response?.data?.isAccountLocked) {
        setPasswordErrorMsg(i18next.t("sign_in.account_lock"));
      } else {
        const isGenericDomain = Object.keys(DomainEnum).some((key) => DomainEnum[key] === domain);

        setPasswordErrorMsg(
          isGenericDomain ? t("generic_error.Invalid_login_attempt") : t("sign_in.email_error_alert"),
        );
      }

      setdisableBtn(false);
    }
  };

  const signingResponse = async (signInResponse) => {
    setLoginAttemptCount(0);
    setShowCaptcha(false);
    setCaptchaToken(null);

    const isGuestUser = signInResponse?.isGuestUser;
    const isPerquisiteBountyEnable = signInResponse?.isPerquisiteBountyEnable;
    const urlParams = new URLSearchParams(window.location.search);
    const prtl = urlParams.get("prtl");
    if (prtl) {
      createCookie("queryprtlsrc", prtl, 1);
    }
    try {
      handlingTransOCRCookieSignIn(
        ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
        signInResponse.validUserGuid,
        ABTEST_TRANSLATIONOCR_COOKIE,
      );
      //for old user delete cookie and for new user update cookie
      // const response = await getABtestData(ABTESTID_SUMMARIZER, signInResponse.validUserGuid);
      // if (!!response) {
      //   if (response.abTestVariant !== 0) {
      //     updateCookie(ABTESTID_SUMMARIZER, response.abTestVariant);
      //   } else {
      //     deleteCookie(ABTEST_SUMMARIZER_COOKIE);
      //   }
      // }
      //Annotation Provide ABTEST : for old user delete cookie and for new user update cookie
      // const response_anp = await getABtestData(ABTESTID_ANNOTATION_PROVIDER, signInResponse.validUserGuid);
      // if (!!response_anp) {
      //   if (response_anp.abTestVariant !== 0) {
      //     updateCookie(ABTESTID_ANNOTATION_PROVIDER, response_anp.abTestVariant);
      //   } else {
      //     deleteCookie(ABTEST_ANNOTATION_PROVIDER_COOKIE);
      //   }
      // }
      // //VWO PAYMENT FUNNEL ABTEST : for old user delete cookie and for new user update cookie
      // const response_vwo_pyfn = await getABtestData(ABTESTID_VWO_PAYMENT_FUNNEL, signInResponse.validUserGuid);
      // if (!!response_vwo_pyfn) {
      //   if (response_vwo_pyfn.abTestVariant !== 0) {
      //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL, response_vwo_pyfn.abTestVariant);
      //   } else {
      //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_COOKIE);
      //   }
      // }
      // //VWO PAYMENT FUNNEL MOBILE ABTEST : for old user delete cookie and for new user update cookie
      // const response_vwo_pyfn_m = await getABtestData(ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE, signInResponse.validUserGuid);
      // if (!!response_vwo_pyfn_m) {
      //   if (response_vwo_pyfn_m.abTestVariant !== 0) {
      //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE, response_vwo_pyfn_m.abTestVariant);
      //   } else {
      //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE);
      //   }
      // }
      //VWO PAYMENT CHECKOUT  ABTEST : for old user delete cookie and for new user update cookie
      // const response_vwo_pyfn_chk = await getABtestData(ABTESTID_VWO_PAYMENT_CHECKOUT, signInResponse.validUserGuid);
      // if (!!response_vwo_pyfn_chk) {
      //   if (response_vwo_pyfn_chk.abTestVariant !== 0) {
      //     updateCookie(ABTESTID_VWO_PAYMENT_CHECKOUT, response_vwo_pyfn_chk.abTestVariant);
      //   } else {
      //     deleteCookie(ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE);
      //   }
      // }
      //ABTEST_APP_EDITOR : for old user delete cookie and for new user update cookie
      // const response_app_editor = await getABtestData(ABTEST_APP_EDITOR, signInResponse.validUserGuid);
      // if (!!response_app_editor) {
      //   if (response_app_editor.abTestVariant !== 0) {
      //     updateCookie(ABTEST_APP_EDITOR, response_app_editor.abTestVariant);
      //   } else {
      //     deleteCookie(ABTEST_APP_EDITOR_COOKIE);
      //   }
      // }

      //Image AI provider ABTEST : for old user delete cookie and for new user update cookie
      const response_image_ai_editor = await getABtestData(ABTEST_IMAGE_AI_GENERATION, signInResponse.validUserGuid);
      if (!!response_image_ai_editor) {
        if (response_image_ai_editor.abTestVariant !== 0) {
          updateCookie(ABTEST_IMAGE_AI_GENERATION, response_image_ai_editor.abTestVariant);
        } else {
          deleteCookie(ABTEST_IMAGE_AI_FUNNEL_COOKIE);
        }
      }
      // const response_PDF_LP_US = await getABtestData(ABTEST_COMPARE_PDF_LP_US_ENG, signInResponse.validUserGuid);
      // if (!!response_PDF_LP_US) {
      //   if (response_PDF_LP_US.abTestVariant !== 0) {
      //     updateCookie(ABTEST_COMPARE_PDF_LP_US_ENG, response_PDF_LP_US.abTestVariant);
      //   } else {
      //     deleteCookie(ABTEST_COMPARE_PDF_LP_COOKIE);
      //   }
      // }

      //PDFSIMPLI view-b editor ABTEST : for old user delete cookie and for new user update cookie
      // const response_pdfsimpli_editor = await getABtestData(ABTESTID_PDFSIMPLI_EDITOR, signInResponse.validUserGuid);
      // if (!!response_pdfsimpli_editor) {
      //   if (response_pdfsimpli_editor.abTestVariant !== 0) {
      //     updateCookie(ABTESTID_PDFSIMPLI_EDITOR, response_pdfsimpli_editor.abTestVariant);
      //   } else {
      //     deleteCookie(ABTESTID_PDFSIMPLI_EDITOR_COOKIE);
      //   }
      // }
      if (currentDomain() === DomainEnum.PDFSIMPLI && !(locale && locale !== "en")) {
        const response_dashboard = await getABtestData(DASHBOARD_ABTESTID, signInResponse.validUserGuid);
        if (!!response_dashboard) {
          if (response_dashboard.abTestVariant !== 0) {
            updateCookie(DASHBOARD_ABTESTID, response_dashboard.abTestVariant);
          } else {
            deleteCookie(DASHBOARD_ABTESTID_COOKIE);
          }
        }
      }
    } catch (error) {
      console.error("Error in checkAbTest:", error);
    }

    if (!!signInResponse && signInResponse.isAccountLocked) {
      setPasswordError(true);
      setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
      setPwd("");
      setdisableBtn(false);
      setShowLoader("d-none");
    } else {
      if (!!signInResponse && signInResponse.isMigratedUser) {
        setPasswordError(true);
        setPasswordErrorMsg(`${i18next.t("sign_in.migrated_user")}`);
        setPwd("");
        setdisableBtn(false);
        setShowLoader("d-none");
      } else if (!!signInResponse) {
        const { validUserGuid, isMigratedUser } = signInResponse;
        if (validUserGuid == EMPTY_GUID) {
          setPasswordError(true);
          setPasswordErrorMsg(`${i18next.t("sign_in.no_account")}`);
          setPwd("");
          setdisableBtn(false);
          setShowLoader("d-none");
        } else if (isMigratedUser) {
          setPasswordError(true);
          setPasswordErrorMsg(`${i18next.t("sign_in.migrated_user")}`);
          setPwd("");
          setdisableBtn(false);
          setShowLoader("d-none");
        } else {
          let data = {
            Id: CreateUUID(),
            UserId: validUserGuid,
            VisitorId: getQueryParam("extInstalledId") ? getQueryParam("extInstalledId") : readCookie("visitorGuid"),
            VisitId: readCookie("visitGuid"),
          };

          eventServicePost(data).then((serviceResponse) => { });

          // queryId needs to be populated from query string if any
          // let queryId = queryParams.has("qid") ? queryParams.get("qid") : "";
          const orgId = queryParams.get("orgid");
          const resetPwd = queryParams.get("resetpwd");

          if (orgId && queryParams.has("gusr")) {
            const onboardData = {
              organizationId: orgId,
              guestUserEmail: emailId.trim(),
            };
            try {
              await UserServiceApi.onboardOrgUserRole(onboardData);
            } catch (error) {
              console.error("Onboarding failed", error);
            }
          }

          if (orgId && resetPwd === "true" && currentDomain() === DomainEnum.SIGNSIMPLI) {
            let localeval = "";
            if (!!locale && locale !== "") {
              localeval = "/" + locale;
            }
            const data = {
              serviceCode: getServiceCodeForgotPwd(),
              email: emailId.trim(),
              tenantId: getTenantId(),
              tenantgroupId: getTenantGroupId(),
              locale: !!localeval ? localeval : "en",
              IsLoginAppEnabled: true,
              SendMail: false,
            };
            const response = await triggerResetPasswordFromSignIn(data);
            if (!!response) {
              const encodedToken = encodeURIComponent(response.passwordResetToken);
              navigate(`/app/account/reset-password?uid=${validUserGuid}&cd=${encodedToken}`);
            } else {
              console.log("Error in triggering reset password.");
            }
          } else if (checkQueryParams(queryParams)) {
            setIsProcessing(true);
            ProcessSignInRequest(
              queryParams,
              validUserGuid,
              isPerquisiteBountyEnable,
              false,
              isGuestUser,
              locale,
              false,
            ).then((processResponse) => {
              console.log("Process response and before navigate...", processResponse);
              if (!!processResponse) {
                console.log("Process response and navigate...");
                NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
              } else {
                console.log("error at process response...");
                NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
              }
            });
          } else {
            console.log("Direct login.");
            if (isSecureSimpli) {
              const mfaData = {
                userGuid: validUserGuid,
                ipAddress: readCookie("ipAddress"),
                loginDeviceType: getDeviceType(),
                userAgent: navigator.userAgent,
                userAgentHash: "",
                macAddress: "",
                mfaRequired: true,
                mfaVerified: false,
                visitId: readCookie("visitGuid"),
                tenantId: getTenantId(),
              };
              await saveMfaVerificationData(mfaData);
              NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
            }
            NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
          }
          //NavigationHandler(validUserGuid, isPremiumUser);
        }
      }
    }
  };

  const NavigationHandler = (validUserGuid, isPerquisiteBountyEnable = false, isGuestUser) => {
    //
    const tgt = queryParams.get("tgt");

    if (tgt) {
      const hash = window.location.hash; // "#users-team-settings"

      const finalUrl = tgt + (hash || "");

      window.location.assign(finalUrl);
      return;
    }
    if (currentDomain() === DomainEnum.RESUMEBUILD || isPSRB) {
      let docid = "";
      let type = "";
      if (queryParams.has("docid")) {
        docid = queryParams.get("docid");
      }
      if (queryParams.has("type")) {
        // doctype comes from resume flow
        type = queryParams.get("type");
      } else if (queryParams.has("doctype")) {
        // doctype comes from WP sign in page, later will be doctype and type will be removed to be in sync.
        type = queryParams.get("doctype");
      }
      if (!!docid) {
        UserDocMapping(docid, validUserGuid).then((mappingResponse) => {
          getUserDocumentAttributes(validUserGuid, 10)
            .then((abridgedResponse) => {
              NavigationHandlerForRB(locale, docid, type, abridgedResponse.docCount);
            })
            .catch((error) => {
              NavigationHandlerForRB(locale, docid, type, 0);
            });
        });
      } else if (!!type) {
        NavigationHandlerForRB(locale, "", type, 0);
      } else {
        getUserDocumentAttributes(validUserGuid, 10)
          .then((abridgedResponse) => {
            if (!!abridgedResponse) {
              NavigationHandlerForRB(locale, 0, "", abridgedResponse.docCount);
            } else {
              NavigationHandlerForRB(locale, docid, type, 0);
            }
          })
          .catch((error) => {
            NavigationHandlerForRB(locale, "", "", 0);
          });
      }
    } else if (currentDomain() === DomainEnum.PDFSIMPLI) {
      NavigationHandlerForPDFsimpli(locale, isGuestUser, isPerquisiteBountyEnable);
    } else if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      NavigationHandlerForSignSimpli(locale, isGuestUser, isPerquisiteBountyEnable);
    } else if (currentDomain() === DomainEnum.WORKSIMPLI) {
      NavigationHandlerForWorkSimpli(locale, isGuestUser, isPerquisiteBountyEnable);
    } else if (currentDomain() === DomainEnum.LEGALSIMPLI) {
      NavigationHandlerForLegalSimpli(isPerquisiteBountyEnable, isGuestUser);
    }

    // NOTE ::: If local env then redirect on home page else on dashboard.
    else if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
      navigate(PathRedirectDashboard.cstm);
    } else {
      redirectToDashboardWithLocale(locale);
    }
  };
  const NavigationHandlerForRB = (locale, docId, type, numberOfDocs) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.RESUMEBUILD || isPSRB) {
      urlPrefix = getResumeBuildBaseURL;
      if (isPSRB) {
        urlPrefix = getPdfSimpliBaseURL;
      }
      if (!!type && type.toLowerCase() == "cvlt") {
        if (isPSRB) {
          // Changes for PSRB Cover letter Path
          if (!!docId) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review", isPSRB, type) + "?docid=" + docId;
          } else {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letters", isPSRB, type);
          }
        } else {
          if (!!docId) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review", isPSRB) + "?docid=" + docId;
          } else {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letters", isPSRB);
          }
        }
      } else {
        if (!!docId) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review", isPSRB) + "?docid=" + docId;
        } else if (numberOfDocs > 0) {
          if (isPSRB) {
            urlPost = getDashboardLinkWithLocale(locale);
            //urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard",isPSRB);
          } else {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes", isPSRB);
          }
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction", isPSRB);
        }
      }
      console.log("NavigationHandlerForRB ", urlPost);
      window.location.assign(urlPost);
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };

  const NavigationHandlerForPDFsimpli = (locale, isGuestUser, isPerquisiteBountyEnable) => {
    let urlPrefix = "";
    let urlPost = "";
    urlPrefix = getPdfSimpliBaseURL;
    const offerType = getQueryParam("opt");
    isOfferPlanUser = ["1", "10"].includes(offerType);
    if (isOfferPlanUser) {
      urlPost = getPdfSimpliBaseURL + "/app/billing";
    } else {
      if (!isPerquisiteBountyEnable && isPerquisiteBountyEnable === false && !isGuestUser && !queryParams.has("pgid")) {
        if (isSecureSimpli) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard") + "?lock=1";
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
        }
        if (queryParams?.has("querydata") && queryParams?.get("cname")?.toLowerCase() === CategoryName.IMAGE_AI) {
          urlPost += "?f=image";
        } else if (
          queryParams?.has("querydata") &&
          queryParams?.get("cname")?.toLowerCase().includes(CategoryName.WRITE_SIMPLI)
        ) {
          urlPost += "?f=" + queryParams?.get("cname")?.toLowerCase();
        }
        //urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
      } else {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction");
        if (isSecureSimpli) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard") + "?lock=1";
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
        }
        if (queryParams?.has("querydata") && queryParams?.get("cname")?.toLowerCase() === CategoryName.IMAGE_AI) {
          urlPost += "?f=image";
        } else if (
          queryParams?.has("querydata") &&
          queryParams?.get("cname")?.toLowerCase().includes(CategoryName.WRITE_SIMPLI)
        ) {
          urlPost += "?f=" + queryParams?.get("cname")?.toLowerCase();
        }
      }
    }
    window.location.assign(urlPost);
  };

  const NavigationHandlerForSignSimpli = (locale, isGuestUser, isPerquisiteBountyEnable) => {
    let urlPrefix = "";
    let urlPost = "";
    urlPrefix = getSignSimpliBaseURL;
    if (!isPerquisiteBountyEnable && isPerquisiteBountyEnable === false && !isGuestUser && !queryParams.has("pgid")) {
      urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
    } else {
      urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
    }
    window.location.assign(urlPost);
  };
  const NavigationHandlerForWorkSimpli = (locale, isGuestUser, isPerquisiteBountyEnable) => {
    let urlPrefix = getWorksimpliEndPoint;
    let urlPost = "";

    if (!isPerquisiteBountyEnable && !isGuestUser && !queryParams.has("pgid")) {
      console.log("Non paid user..");
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
    } else {
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
    }
    window.location.assign(urlPost);
  };
  const NavigationHandlerForLegalSimpli = async (isPerquisiteBountyEnable, isGuestUser) => {
    const docId = queryParams?.get("docid");
    const uniqueName = queryParams?.get("unqn");
    const validUserGuid = readCookie("userguid");
    const useExternalTemplate = queryParams?.get("useExternalTemplate");
    let urlPrefix = getLegalSimpliBaseURL;
    let urlPost = "";
    try {
      if (docId) {
        await updateUserGuid(docId, validUserGuid);
        DeleteTemplateDocId(docId, false);
        let docOperationBlobdata = getDocOperationBlobData("", validUserGuid, true, "", "", "", "", uniqueName, "");
        let reponseReplaceContainer = await ProcessDocOperationRequest(docOperationBlobdata);
        let jobStatus = await DocOperationJobStatusWithInterval(reponseReplaceContainer.docId);
        if (isPerquisiteBountyEnable || isGuestUser) {
          await generatePDFPath(docId, validUserGuid, useExternalTemplate);
        }
      }
      if (!isPerquisiteBountyEnable && !isGuestUser && !queryParams.has("pgid")) {
        urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
      } else {
        urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
      }
      window.location.assign(urlPost);
    } catch (err) {
      setShowLoader("d-none");
      throw new Error("Error in navigation for legalsimpli");
    }
  };

  const validateData = () => {
    setEmailError(false);
    setPasswordError(false);
    let errors = 0;
    let emailValidator = validateEmail(emailId.trim());
    if (emailValidator.isValid === false) {
      ++errors;
      setEmailError(true);
      setPwd("");
      if (domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI || domain === DomainEnum.WORKSIMPLI) {
        setEmailErrorMsg(emailValidator.errorMessage);
        setPasswordErrorMsg(`${i18next.t("sign_in.wrong_email_format_message")}`);
      } else if (domain === DomainEnum.RESUMEBUILD) {
        setEmailErrorMsg(emailValidator.errorMessage);
      } else if (domain === DomainEnum.LEGALSIMPLI) {
        setPasswordErrorMsg(`${i18next.t("sign_in.no_account")}`);
      } else {
        setEmailErrorMsg(`${i18next.t("generic_error.Invalid_login_attempt")}`);
      }
      return;
    }
    let passwordValidator = validatePassword(pwd);
    if (passwordValidator.isValid === false) {
      ++errors;
      setPasswordError(true);
      if (pwd.length === 0) {
        setPwd("");
        setPasswordErrorMsg(
          domain === DomainEnum.PDFSIMPLI ||
            domain === DomainEnum.RESUMEBUILD ||
            currentDomain() === DomainEnum.SIGNSIMPLI
            ? t("generic_error.Invalid_login_attempt")
            : t("sign_in.password_error_alert"),
        );
      } else {
        setPwd("");
        setPasswordErrorMsg(
          domain === DomainEnum.PDFSIMPLI ||
            domain === DomainEnum.RESUMEBUILD ||
            currentDomain() === DomainEnum.SIGNSIMPLI
            ? t("generic_error.Invalid_login_attempt")
            : t("sign_in.password_error_alert"),
        );
      }
    }
    if (errors > 0) {
      ++errors;
      setdisableBtn(false);
      return false;
    } else {
      setdisableBtn(true);
      return true;
    }
  };
  const responseGoogle = (response, accessToken) => {
    let fromGoogle = true;
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setEmailError(false);

      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: readCookie("country"),
          currencyCD: readCookie("currency"),
          portalCD: getPortalCD(locale),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(subDomainParam),
          tenantGroupId: getTenantGroupId(),
          designVersion: "reskin",
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id,
        },
      };

      signUpAsExternalUser(externalData)
        .then((response) => {
          if (!!response) {
            const authData = {
              Username: email.trim(),
              UserGuid: response.userGuid,
              Email: email.trim(),
            };
            authUser(authData, subDomainParam)
              .then(async (authResponse) => {
                if (!!authResponse) {
                  await clearIndexedDB();
                  let data = {
                    Id: CreateUUID(),
                    UserId: response.userGuid,
                    VisitorId: getQueryParam("extInstalledId")
                      ? getQueryParam("extInstalledId")
                      : readCookie("visitorGuid"),
                    VisitId: readCookie("visitGuid"),
                  };
                  eventServicePost(data).then((eventServiceResponse) => { });
                  if (response.isSocialUserExists === true) {
                    try {
                      console.log("social user exists..");
                      handlingTransOCRCookieSignIn(
                        ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
                        response.userGuid,
                        ABTEST_TRANSLATIONOCR_COOKIE,
                      );
                      //for old user delete cookie and for new user update cookie
                      // const abResponse = await getABtestData(ABTESTID_SUMMARIZER, response.userGuid);
                      // if (!!abResponse) {
                      //   if (abResponse.abTestVariant !== 0) {
                      //     updateCookie(ABTESTID_SUMMARIZER, abResponse.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTEST_SUMMARIZER_COOKIE);
                      //   }
                      // }
                      //Annotation Provide ABTEST : for old user delete cookie and for new user update cookie
                      // const response_anp = await getABtestData(ABTESTID_ANNOTATION_PROVIDER, response.userGuid);
                      // if (!!response_anp) {
                      //   if (response_anp.abTestVariant !== 0) {
                      //     updateCookie(ABTESTID_ANNOTATION_PROVIDER, response_anp.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTEST_ANNOTATION_PROVIDER_COOKIE);
                      //   }
                      // }
                      // //VWO PAYMENT FUNNEL ABTEST : for old user delete cookie and for new user update cookie
                      // const response_vwo_pyfn = await getABtestData(ABTESTID_VWO_PAYMENT_FUNNEL, response.userGuid);
                      // if (!!response_vwo_pyfn) {
                      //   if (response_vwo_pyfn.abTestVariant !== 0) {
                      //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL, response_vwo_pyfn.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_COOKIE);
                      //   }
                      // }
                      // //VWO PAYMENT FUNNEL MOBILE ABTEST : for old user delete cookie and for new user update cookie
                      // const response_vwo_pyfn_m = await getABtestData(
                      //   ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE,
                      //   response.userGuid
                      // );
                      // if (!!response_vwo_pyfn_m) {
                      //   if (response_vwo_pyfn_m.abTestVariant !== 0) {
                      //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE, response_vwo_pyfn_m.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE);
                      //   }
                      // }
                      //VWO PAYMENT CHECKOUT  ABTEST : for old user delete cookie and for new user update cookie
                      // const response_vwo_pyfn_chk = await getABtestData(
                      //   ABTESTID_VWO_PAYMENT_CHECKOUT,
                      //   response.userGuid
                      // );
                      // if (!!response_vwo_pyfn_chk) {
                      //   if (response_vwo_pyfn_chk.abTestVariant !== 0) {
                      //     updateCookie(ABTESTID_VWO_PAYMENT_CHECKOUT, response_vwo_pyfn_chk.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE);
                      //   }
                      // }
                      //ABTEST_APP_EDITOR : for old user delete cookie and for new user update cookie
                      // const response_app_editor = await getABtestData(ABTEST_APP_EDITOR, response.userGuid);
                      // if (!!response_app_editor) {
                      //   if (response_app_editor.abTestVariant !== 0) {
                      //     updateCookie(ABTEST_APP_EDITOR, response_app_editor.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTEST_APP_EDITOR_COOKIE);
                      //   }
                      // }

                      //Image AI provider ABTEST : for old user delete cookie and for new user update cookie
                      const response_image_ai_editor = await getABtestData(
                        ABTEST_IMAGE_AI_GENERATION,
                        response.userGuid,
                      );
                      if (!!response_image_ai_editor) {
                        if (response_image_ai_editor.abTestVariant !== 0) {
                          updateCookie(ABTEST_IMAGE_AI_GENERATION, response_image_ai_editor.abTestVariant);
                        } else {
                          deleteCookie(ABTEST_IMAGE_AI_FUNNEL_COOKIE);
                        }
                      }
                      // const response_PDF_LP_US = await getABtestData(ABTEST_COMPARE_PDF_LP_US_ENG, response.userGuid);
                      // if (!!response_PDF_LP_US) {
                      //   if (response_PDF_LP_US.abTestVariant !== 0) {
                      //     updateCookie(ABTEST_COMPARE_PDF_LP_US_ENG, response_PDF_LP_US.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTEST_COMPARE_PDF_LP_COOKIE);
                      //   }
                      // }

                      //PDFSIMPLI view-b editor ABTEST : for old user delete cookie and for new user update cookie
                      // const response_pdfsimpli_editor = await getABtestData(
                      //   ABTESTID_PDFSIMPLI_EDITOR,
                      //   response.userGuid,
                      // );
                      // if (!!response_pdfsimpli_editor) {
                      //   if (response_pdfsimpli_editor.abTestVariant !== 0) {
                      //     updateCookie(ABTESTID_PDFSIMPLI_EDITOR, response_pdfsimpli_editor.abTestVariant);
                      //   } else {
                      //     deleteCookie(ABTESTID_PDFSIMPLI_EDITOR_COOKIE);
                      //   }
                      // }
                      if (currentDomain() === DomainEnum.PDFSIMPLI && !(locale && locale !== "en")) {
                        const response_dashboard = await getABtestData(DASHBOARD_ABTESTID, response.userGuid);
                        if (!!response_dashboard) {
                          if (response_dashboard.abTestVariant !== 0) {
                            updateCookie(DASHBOARD_ABTESTID, response_dashboard.abTestVariant);
                          } else {
                            deleteCookie(DASHBOARD_ABTESTID_COOKIE);
                          }
                        }
                      }
                    } catch (error) {
                      console.error("Error in checkAbTest:", error);
                    }
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                          IpAddress: addResponse[4],
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then((eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignInRequest(queryParams, response.userGuid, true).then((processResponse) => {
                                    if (!!processResponse) {
                                      console.log("Process response and navigate...");
                                      if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                        NavigationHandler(
                                          response.userGuid,
                                          PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
                                        );
                                      } else {
                                        NavigationHandler(response.userGuid);
                                      }
                                    } else {
                                      console.log("error at process response...");
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      NavigationHandler(response.userGuid);
                                    }
                                  });
                                } else {
                                  // Direct Sign up
                                  if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                    NavigationHandler(
                                      response.userGuid,
                                      PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
                                    );
                                  } else {
                                    NavigationHandler(response.userGuid);
                                  }
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            //if response part of saveuseraddress api
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        }); //saveuseraddress api
                      } else {
                        //if response part of getaddress api
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } else {
                    ConductABTest(response, externalData.createUser.portalCD, response.userGuid);
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                          IpAddress: addResponse[4],
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then(async (eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignInRequest(queryParams, response.userGuid, false, fromGoogle).then(
                                    async (processResponse) => {
                                      if (!!processResponse) {
                                        if (
                                          (currentDomain() === DomainEnum.PDFSIMPLI && !isPSRB) ||
                                          currentDomain() === DomainEnum.WORKSIMPLI ||
                                          currentDomain() === DomainEnum.SIGNSIMPLI
                                        ) {
                                          await sendWelcomeEmail(response.userGuid, locale, true);
                                        }
                                        console.log("Process response and navigate...");
                                        NavigationHandler(response.userGuid, false);
                                      } else {
                                        console.log("error at process response...");
                                        NavigationHandler(response.userGuid, false);
                                      }
                                    },
                                  );
                                } else {
                                  if (
                                    currentDomain() === DomainEnum.WORKSIMPLI ||
                                    currentDomain() === DomainEnum.SIGNSIMPLI
                                  ) {
                                    if (!isPSRB) {
                                      await sendWelcomeEmail(response.userGuid, locale, true);
                                    }
                                    await addWelcomeDocument(response.userGuid);
                                  }
                                  // Direct Sign up
                                  console.log(" Direct Sign up");
                                  NavigationHandler(response.userGuid, false);
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        });
                      } else {
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } //else part of isSocialUserExists flag
                } else {
                  setShowLoader("d-none");
                  setdisableBtn(false);
                  setLoginError(true);
                  setLoginErrorMessage(t("generic_error.inaction_message"));
                }
              })
              .catch((error) => {
                setShowLoader("d-none");
                setLoginError(true);
                setLoginErrorMessage(error.message);
              });
          } else {
            setShowLoader("d-none");
            // toggleLoader(false);
            setdisableBtn(false);
            setLoginError(true);
            setLoginErrorMessage(t("sign_up.user_exists"));
          }
        })
        .catch((error) => {
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          if (error.response?.data?.isAccountLocked) {
            setPasswordError(true);
            setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI ||
                domain === DomainEnum.RESUMEBUILD ||
                currentDomain() === DomainEnum.SIGNSIMPLI
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert"),
            );
          }
        });

      // signUpExternalUser(externalData)
      //   .then((response) => {
      //     if (!!response) {
      //       let eventData = {
      //         Id: CreateUUID(),
      //         UserId: response.UserGuid,
      //         VisitorId: readCookie("visitorGuid"),
      //         VisitId: readCookie("visitGuid"),
      //       };
      //       eventServicePost(eventData).then((serviceResponse) => {});

      //       NavigationHandler(response.UserGuid);
      //     }
      //   })
      //   .catch((error) => {
      //     setLoginError(true);
      //     setLoginErrorMessage(error.message);
      //   });

      // let emailTest = email;
    }
  };
  const responseFacebook = (response) => {
    let fromFaceBook = true;
    if (!!response && response.status !== "unknown") {
      setShowLoader("d-block");
      setEmailError(false);
      const { name, email, id } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            portalCD: getPortalCD(locale),
            currencyCD: readCookie("currency"),
            parentUserGuid: "",
            firstName: name,
            lastName: "",
            company: "",
            title: "",
            email: email, //email
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 1,
            providerKey: id, // "100732998798818",
          },
        };

        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              authUser(authData, subDomainParam)
                .then(async (authResponse) => {
                  if (!!authResponse) {
                    await clearIndexedDB();
                    let data = {
                      Id: CreateUUID(),
                      UserId: response.userGuid,
                      VisitorId: readCookie("visitorGuid"),
                      VisitId: readCookie("visitGuid"),
                    };
                    if (response.isSocialUserExists === true) {
                      try {
                        handlingTransOCRCookieSignIn(
                          ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
                          response.userGuid,
                          ABTEST_TRANSLATIONOCR_COOKIE,
                        );
                        //for old user delete cookie and for new user update cookie
                        // const abResponse = await getABtestData(ABTESTID_SUMMARIZER, response.userGuid);
                        // if (!!abResponse) {
                        //   if (abResponse.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_SUMMARIZER, abResponse.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_SUMMARIZER_COOKIE);
                        //   }
                        // }
                        //Annotation Provide ABTEST : for old user delete cookie and for new user update cookie
                        // const response_anp = await getABtestData(ABTESTID_ANNOTATION_PROVIDER, response.userGuid);
                        // if (!!response_anp) {
                        //   if (response_anp.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_ANNOTATION_PROVIDER, response_anp.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_ANNOTATION_PROVIDER_COOKIE);
                        //   }
                        // }
                        // //ABTESTID_VWO_PAYMENT_FUNNEL ABTEST : for old user delete cookie and for new user update cookie
                        // const response_vwo_pyfn = await getABtestData(ABTESTID_VWO_PAYMENT_FUNNEL, response.userGuid);
                        // if (!!response_vwo_pyfn) {
                        //   if (response_vwo_pyfn.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL, response_vwo_pyfn.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_COOKIE);
                        //   }
                        // }
                        // //ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE ABTEST : for old user delete cookie and for new user update cookie
                        // const response_vwo_pyfn_m = await getABtestData(
                        //   ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE,
                        //   response.userGuid
                        // );
                        // if (!!response_vwo_pyfn_m) {
                        //   if (response_vwo_pyfn_m.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE, response_vwo_pyfn_m.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE);
                        //   }
                        // }
                        //VWO PAYMENT CHECKOUT  ABTEST : for old user delete cookie and for new user update cookie
                        // const response_vwo_pyfn_chk = await getABtestData(
                        //   ABTESTID_VWO_PAYMENT_CHECKOUT,
                        //   response.userGuid
                        // );
                        // if (!!response_vwo_pyfn_chk) {
                        //   if (response_vwo_pyfn_chk.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_VWO_PAYMENT_CHECKOUT, response_vwo_pyfn_chk.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE);
                        //   }
                        // }
                        //ABTEST_APP_EDITOR ABTEST : for old user delete cookie and for new user update cookie
                        // const response_app_editor = await getABtestData(ABTEST_APP_EDITOR, response.userGuid);
                        // if (!!response_app_editor) {
                        //   if (response_app_editor.abTestVariant !== 0) {
                        //     updateCookie(ABTEST_APP_EDITOR, response_app_editor.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_APP_EDITOR_COOKIE);
                        //   }
                        // }

                        //Image AI provider ABTEST : for old user delete cookie and for new user update cookie
                        const response_image_ai_editor = await getABtestData(
                          ABTEST_IMAGE_AI_GENERATION,
                          response.userGuid,
                        );
                        if (!!response_image_ai_editor) {
                          if (response_image_ai_editor.abTestVariant !== 0) {
                            updateCookie(ABTEST_IMAGE_AI_GENERATION, response_image_ai_editor.abTestVariant);
                          } else {
                            deleteCookie(ABTEST_IMAGE_AI_FUNNEL_COOKIE);
                          }
                        }

                        // const response_PDF_LP_US = await getABtestData(ABTEST_COMPARE_PDF_LP_US_ENG, response.userGuid);
                        // if (!!response_PDF_LP_US) {
                        //   if (response_PDF_LP_US.abTestVariant !== 0) {
                        //     updateCookie(ABTEST_COMPARE_PDF_LP_US_ENG, response_PDF_LP_US.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_COMPARE_PDF_LP_COOKIE);
                        //   }
                        // }

                        //PDFSIMPLI view-b editor ABTEST : for old user delete cookie and for new user update cookie
                        // const response_pdfsimpli_editor = await getABtestData(
                        //   ABTESTID_PDFSIMPLI_EDITOR,
                        //   response.userGuid,
                        // );
                        // if (!!response_pdfsimpli_editor) {
                        //   if (response_pdfsimpli_editor.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_PDFSIMPLI_EDITOR, response_pdfsimpli_editor.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTESTID_PDFSIMPLI_EDITOR_COOKIE);
                        //   }
                        // }
                        if (currentDomain() === DomainEnum.PDFSIMPLI && !(locale && locale !== "en")) {
                          const response_dashboard = await getABtestData(DASHBOARD_ABTESTID, response.userGuid);
                          if (!!response_dashboard) {
                            if (response_dashboard.abTestVariant !== 0) {
                              updateCookie(DASHBOARD_ABTESTID, response_dashboard.abTestVariant);
                            } else {
                              deleteCookie(DASHBOARD_ABTESTID_COOKIE);
                            }
                          }
                        }
                      } catch (error) {
                        console.error("Error in checkAbTest:", error);
                      }
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then((eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    setIsProcessing(true);
                                    ProcessSignInRequest(queryParams, response.userGuid, true).then(
                                      (processResponse) => {
                                        if (!!processResponse) {
                                          console.log("Process response and navigate...");
                                          if (
                                            !!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)
                                          ) {
                                            NavigationHandler(
                                              response.userGuid,
                                              PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
                                            );
                                          } else {
                                            NavigationHandler(response.userGuid);
                                          }
                                        } else {
                                          console.log("error at process response...");
                                          setShowLoader("d-none");
                                          setdisableBtn(false);
                                          setLoginError(true);
                                          setLoginErrorMessage(t("generic_error.inaction_message"));
                                          NavigationHandler(response.userGuid);
                                        }
                                      },
                                    );
                                  } else {
                                    // Direct Sign up
                                    if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                      NavigationHandler(
                                        response.userGuid,
                                        PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
                                      );
                                    } else {
                                      NavigationHandler(response.userGuid);
                                    }
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              //if response part of saveuseraddress api
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          }); //saveuseraddress api
                        } else {
                          //if response part of getaddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } else {
                      ConductABTest(response, externalData.createUser.portalCD, response.userGuid);
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then(async (eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    setIsProcessing(true);
                                    ProcessSignInRequest(queryParams, response.userGuid, false, fromFaceBook).then(
                                      async (processResponse) => {
                                        if (!!processResponse) {
                                          if (
                                            (currentDomain() === DomainEnum.PDFSIMPLI && !isPSRB) ||
                                            currentDomain() === DomainEnum.WORKSIMPLI ||
                                            currentDomain() === DomainEnum.SIGNSIMPLI
                                          ) {
                                            await sendWelcomeEmail(response.userGuid, locale, true);
                                          }
                                          console.log("Process response and navigate...");
                                          NavigationHandler(response.userGuid, false);
                                        } else {
                                          console.log("error at process response...");
                                          NavigationHandler(response.userGuid, false);
                                        }
                                      },
                                    );
                                  } else {
                                    // Direct Sign up
                                    if (
                                      currentDomain() === DomainEnum.WORKSIMPLI ||
                                      currentDomain() === DomainEnum.SIGNSIMPLI
                                    ) {
                                      if (!isPSRB) {
                                        await sendWelcomeEmail(response.userGuid, locale, true);
                                      }
                                      await addWelcomeDocument(response.userGuid);
                                    }

                                    console.log(" Direct Sign up");
                                    NavigationHandler(response.userGuid, false);
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } //else part of isSocialUserExists flag
                  } else {
                    setShowLoader("d-none");
                    setdisableBtn(false);
                    setLoginError(true);
                    setLoginErrorMessage(t("generic_error.inaction_message"));
                  }
                })
                .catch((error) => {
                  setShowLoader("d-none");
                  setLoginError(true);
                  setLoginErrorMessage(error.message);
                });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setLoginErrorMessage(t("sign_up.user_exists"));
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI ||
                  domain === DomainEnum.RESUMEBUILD ||
                  currentDomain() === DomainEnum.SIGNSIMPLI
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert"),
              );
            }
          });

        // signUpExternalUser(externalData)
        //   .then((response) => {
        //     if (!!response) {
        //       let eventData = {
        //         Id: CreateUUID(),
        //         UserId: response.UserGuid,
        //         VisitorId: readCookie("visitorGuid"),
        //         VisitId: readCookie("visitGuid"),
        //       };
        //       eventServicePost(eventData).then((serviceResonse) => {});

        //       NavigationHandler(response.UserGuid);
        //     }
        //   })
        //   .catch((error) => {
        //     setLoginError(true);
        //     setLoginErrorMessage(error.message);
        //   });
      } else {
        setPasswordError(true);
        setPasswordErrorMsg(`${i18next.t("sign_in.facebook_invalid")}`);
        setPwd("");
        //setdisableBtn(false);
        setShowLoader("d-none");
      }
    }
  };

  const responseApple = (response, code) => {
    if (!!response && !!code) {
      setShowLoader("d-block");
      setEmailError(false);
      const { email, fullName, sub } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            currencyCD: readCookie("currency"),
            portalCD: getPortalCD(locale),
            parentUserGuid: "",
            firstName: fullName,
            lastName: "",
            company: "",
            title: "",
            email: email,
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 4,
            providerKey: sub,
          },
        };
        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
              createCookie("userguid", response.userGuid, 1);
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              authUser(authData, subDomainParam)
                .then(async (authResponse) => {
                  if (!!authResponse) {
                    await clearIndexedDB();
                    let data = {
                      Id: CreateUUID(),
                      UserId: response.userGuid,
                      VisitorId: getQueryParam("extInstalledId")
                        ? getQueryParam("extInstalledId")
                        : readCookie("visitorGuid"),
                      VisitId: readCookie("visitGuid"),
                    };
                    eventServicePost(data).then((eventServiceResponse) => { });
                    if (response.isSocialUserExists === true) {
                      try {
                        handlingTransOCRCookieSignIn(
                          ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
                          response.userGuid,
                          ABTEST_TRANSLATIONOCR_COOKIE,
                        );
                        //for old user delete cookie and for new user update cookie
                        // const abResponse = await getABtestData(ABTESTID_SUMMARIZER, response.userGuid);
                        // if (!!abResponse) {
                        //   if (abResponse.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_SUMMARIZER, abResponse.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_SUMMARIZER_COOKIE);
                        //   }
                        // }
                        //Annotation Provide ABTEST : for old user delete cookie and for new user update cookie
                        // const response_anp = await getABtestData(ABTESTID_ANNOTATION_PROVIDER, response.userGuid);
                        // if (!!response_anp) {
                        //   if (response_anp.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_ANNOTATION_PROVIDER, response_anp.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_ANNOTATION_PROVIDER_COOKIE);
                        //   }
                        // }
                        // //VWO PAYMENT FUNNEL ABTEST : for old user delete cookie and for new user update cookie
                        // const response_vwo_pyfn = await getABtestData(ABTESTID_VWO_PAYMENT_FUNNEL, response.userGuid);
                        // if (!!response_vwo_pyfn) {
                        //   if (response_vwo_pyfn.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL, response_vwo_pyfn.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_COOKIE);
                        //   }
                        // }
                        // //VWO PAYMENT FUNNEL MOBILE ABTEST : for old user delete cookie and for new user update cookie
                        // const response_vwo_pyfn_m = await getABtestData(
                        //   ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE,
                        //   response.userGuid
                        // );
                        // if (!!response_vwo_pyfn_m) {
                        //   if (response_vwo_pyfn_m.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE, response_vwo_pyfn_m.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE);
                        //   }
                        // }
                        //VWO PAYMENT CHECKOUT  ABTEST : for old user delete cookie and for new user update cookie
                        // const response_vwo_pyfn_chk = await getABtestData(
                        //   ABTESTID_VWO_PAYMENT_CHECKOUT,
                        //   response.userGuid
                        // );
                        // if (!!response_vwo_pyfn_chk) {
                        //   if (response_vwo_pyfn_chk.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_VWO_PAYMENT_CHECKOUT, response_vwo_pyfn_chk.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE);
                        //   }
                        // }
                        //ABTEST_APP_EDITOR : for old user delete cookie and for new user update cookie
                        // const response_app_editor = await getABtestData(ABTEST_APP_EDITOR, response.userGuid);
                        // if (!!response_app_editor) {
                        //   if (response_app_editor.abTestVariant !== 0) {
                        //     updateCookie(ABTEST_APP_EDITOR, response_app_editor.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_APP_EDITOR_COOKIE);
                        //   }
                        // }

                        //Image AI provider ABTEST : for old user delete cookie and for new user update cookie
                        const response_image_ai_editor = await getABtestData(
                          ABTEST_IMAGE_AI_GENERATION,
                          response.userGuid,
                        );
                        if (!!response_image_ai_editor) {
                          if (response_image_ai_editor.abTestVariant !== 0) {
                            updateCookie(ABTEST_IMAGE_AI_GENERATION, response_image_ai_editor.abTestVariant);
                          } else {
                            deleteCookie(ABTEST_IMAGE_AI_FUNNEL_COOKIE);
                          }
                        }

                        // const response_PDF_LP_US = await getABtestData(ABTEST_COMPARE_PDF_LP_US_ENG, response.userGuid);
                        // if (!!response_PDF_LP_US) {
                        //   if (response_PDF_LP_US.abTestVariant !== 0) {
                        //     updateCookie(ABTEST_COMPARE_PDF_LP_US_ENG, response_PDF_LP_US.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTEST_COMPARE_PDF_LP_COOKIE);
                        //   }
                        // }

                        //PDFSIMPLI view-b editor ABTEST : for old user delete cookie and for new user update cookie
                        // const response_pdfsimpli_editor = await getABtestData(
                        //   ABTESTID_PDFSIMPLI_EDITOR,
                        //   response.userGuid,
                        // );
                        // if (!!response_pdfsimpli_editor) {
                        //   if (response_pdfsimpli_editor.abTestVariant !== 0) {
                        //     updateCookie(ABTESTID_PDFSIMPLI_EDITOR, response_pdfsimpli_editor.abTestVariant);
                        //   } else {
                        //     deleteCookie(ABTESTID_PDFSIMPLI_EDITOR_COOKIE);
                        //   }
                        // }
                        if (currentDomain() === DomainEnum.PDFSIMPLI && !(locale && locale !== "en")) {
                          const response_dashboard = await getABtestData(DASHBOARD_ABTESTID, response.userGuid);
                          if (!!response_dashboard) {
                            if (response_dashboard.abTestVariant !== 0) {
                              updateCookie(DASHBOARD_ABTESTID, response_dashboard.abTestVariant);
                            } else {
                              deleteCookie(DASHBOARD_ABTESTID_COOKIE);
                            }
                          }
                        }
                      } catch (error) {
                        console.error("Error in checkAbTest:", error);
                      }
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then((eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                      (processResponse) => {
                                        if (!!processResponse) {
                                          console.log("Process response and navigate...");
                                          if (!!isPerquisiteBountyEnable) {
                                            NavigationHandler(
                                              response.userGuid,
                                              isPerquisiteBountyEnable,
                                              response.isSocialUserExists,
                                            );
                                          } else {
                                            NavigationHandler(response.userGuid);
                                          }
                                        } else {
                                          console.log("error at process response...");
                                          setShowLoader("d-none");
                                          setdisableBtn(false);
                                          setLoginError(true);
                                          setLoginErrorMessage(t("generic_error.inaction_message"));
                                          NavigationHandler(response.userGuid);
                                        }
                                      },
                                    );
                                  } else {
                                    // Direct Sign up
                                    if (!!isPerquisiteBountyEnable) {
                                      NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                    } else {
                                      NavigationHandler(response.userGuid);
                                    }
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              //if response part of saveuseraddress api
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          }); //saveuseraddress api
                        } else {
                          //if response part of getaddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } else {
                      ConductABTest(response, externalData.createUser.portalCD, response.userGuid);
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then(async (eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                      async (processResponse) => {
                                        if (!!processResponse) {
                                          if (
                                            (currentDomain() === DomainEnum.PDFSIMPLI && !isPSRB) ||
                                            currentDomain() === DomainEnum.WORKSIMPLI ||
                                            currentDomain() === DomainEnum.SIGNSIMPLI
                                          ) {
                                            await sendWelcomeEmail(response.userGuid, locale, true);
                                          }
                                          console.log("Process response and navigate...");
                                          NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                        } else {
                                          console.log("error at process response...");
                                          NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                        }
                                      },
                                    );
                                  } else {
                                    // Direct Sign up
                                    if (
                                      currentDomain() === DomainEnum.WORKSIMPLI ||
                                      currentDomain() === DomainEnum.SIGNSIMPLI
                                    ) {
                                      if (!isPSRB) {
                                        await sendWelcomeEmail(response.userGuid, locale, true);
                                      }
                                      await addWelcomeDocument(response.userGuid);
                                    }
                                    console.log(" Direct Sign up");
                                    NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } //else part of isSocialUserExists flag
                  } else {
                    setShowLoader("d-none");
                    setdisableBtn(false);
                    setLoginError(true);
                    setLoginErrorMessage(t("generic_error.inaction_message"));
                  }
                })
                .catch((error) => {
                  setShowLoader("d-none");
                  setLoginError(true);
                  setLoginErrorMessage(error.message);
                });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setPwd("");
              setLoginErrorMessage(
                domain === DomainEnum.PDFSIMPLI || currentDomain() === DomainEnum.SIGNSIMPLI
                  ? t("sign_up.email_already_taken")
                  : t("sign_up.user_exists"),
              );
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI ||
                  domain === DomainEnum.RESUMEBUILD ||
                  currentDomain() === DomainEnum.SIGNSIMPLI
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert"),
              );
            }
          });
      } else {
        setShowLoader("d-none");
        setLoginErrorMessage(t("sign_up.apple_invalid"));
        setLoginError(true);
      }
    }
  };

  const pwdNavigate = () => {
    navigate(forgetpwdLink);
  };
  const signUpNavigate = () => {
    navigate(signUpLink);
  };

  const handlingTransOCRCookieSignIn = async (abTestId, userID, abTestCookie) => {
    let retrieveABtest = retrieveAbTestConfiguration(abTestId, abTestCookie);
    if (retrieveABtest.abTestId != null) {
      const response = await getABtestData(abTestId, userID);
      if (!!response && response.abTestVariant != null && response.abTestVariant !== 0) {
        updateCookie(abTestId, response.abTestVariant);
      } else {
        let switchData = {
          AbTestId: retrieveABtest.abTestId,
          UserId: userID,
          VisitorId: readCookie("visitorGuid"),
          portalCD: getPortalCD(locale),
        };
        SwitchVisitorUserAbTest(switchData).then((response) => { });
      }
    }
  };

  let privacyLinksOption = PathHelper(APP_NAVIGATION.PRVY, false);
  let termsAndConditionOption = PathHelper(APP_NAVIGATION.TUSE, false);

  const setUrls = (policy, terms, contact) => {
    setPrivacyPolicy(policy);
    setTermsOfUse(terms);
  };
  useEffect(() => {
    setUrls(privacyLinksOption.cstm, termsAndConditionOption.cstm);
  }, []);

  const AuthenticateJCPartnerUser = async (returnedCodeFromJC, clientID) => {
    try {
      if (locale === undefined) {
        locale = localStorage.getItem("i18nextLng") === "en" ? "" : localStorage.getItem("i18nextLng");
      }
      let portalCD = "SS";
      var jcRequestObject = {
        code: returnedCodeFromJC,
        tenantId: getTenantId(),
        tenantGroupId: getTenantGroupId(),
        portalCD: window.location.hostname.includes("staging") ? "staging-" + portalCD : portalCD,
        countryCD: readCookie("country"),
        locale: "en",
        clientId: clientID,
        IDP: "JUMPCLOUD",
      };

      const domain = DomainEnum.SIGNSIMPLI;

      signInJcUser(jcRequestObject, domain)
        .then(async (signInResponse) => {
          signingResponse(signInResponse);
        })
        .catch((error) => {
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          setPasswordError(true);
          if (error.response?.data?.isAccountLocked) {
            setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI ||
                domain === DomainEnum.RESUMEBUILD ||
                currentDomain() === DomainEnum.SIGNSIMPLI
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert"),
            );
          }
          setdisableBtn(false);
        });

      console.log("AuthenticateJCPartnerUser called with code:", returnedCodeFromJC);
    } catch (error) {
      console.error("AuthenticateUser failed:", error);
      return null;
    }
  };
  return (
    <>
      <Header className="mt-4" />
      <ReactLoader showloader={showLoader} isProcessing={isProcessing} />
      {(() => {
        const domain = currentDomain()?.toLowerCase() || "";
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <PSRSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                appleLogin={appleLogin}
                isOfferPlanValid={isOfferPlanValid}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
                showCaptcha={showCaptcha}
                onCaptchaSuccess={onCaptchaSuccess}
                recaptchaRef={recaptchaRef}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
              />
            );
          case DomainEnum.WORKSIMPLI:
            return (
              <PSRSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                appleLogin={appleLogin}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
              />
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <LegalSimpliSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                appleLogin={appleLogin}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                showCaptcha={showCaptcha}
                onCaptchaSuccess={onCaptchaSuccess}
                recaptchaRef={recaptchaRef}
              />
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <SignSimpliSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                setLoginError={setLoginError}
                setShowLoader={setShowLoader}
                setLoginErrorMessage={setLoginErrorMessage}
                AuthenticateJCPartnerUser={AuthenticateJCPartnerUser}
                appleLogin={appleLogin}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                showCaptcha={showCaptcha}
                onCaptchaSuccess={onCaptchaSuccess}
                recaptchaRef={recaptchaRef}
              />
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <ResumeBuildSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                emailErrorMsg={emailErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                showCaptcha={showCaptcha}
                onCaptchaSuccess={onCaptchaSuccess}
                recaptchaRef={recaptchaRef}
              />
            );
        }
      })()}

      {domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.WORKSIMPLI || domain === DomainEnum.SIGNSIMPLI ? (
        ""
      ) : (
        <Footer />
      )}
    </>
  );
};

export default SignIn;
